import { Controller } from "@hotwired/stimulus";

/**
 * GO4S Design System — sélecteur de module (flyout).
 * Ouvre/ferme le panneau des modules ; ferme au clic extérieur et sur Échap.
 * La classe `is-open` posée sur l'élément racine pilote l'animation CSS.
 */
export default class extends Controller {
  static targets = ["panel", "toggler"];

  toggle() {
    this.element.classList.contains("is-open") ? this.close() : this.open();
  }

  open() {
    this.position();
    this.element.classList.add("is-open");
  }

  close() {
    this.element.classList.remove("is-open");
  }

  // Clic en dehors du composant -> fermeture.
  closeOutside(event) {
    if (!this.element.contains(event.target)) this.close();
  }

  // Le panneau est en position:fixed : on l'ouvre À DROITE de la sidebar, aligné
  // sur la flèche -> il ne croise jamais la sidebar et échappe à son overflow.
  position() {
    if (!this.hasPanelTarget || !this.hasTogglerTarget) return;
    const tr = this.togglerTarget.getBoundingClientRect();
    const sidebar = this.element.closest(".ds-sidebar");
    const left = sidebar ? sidebar.getBoundingClientRect().right : tr.right;
    this.panelTarget.style.left = `${Math.round(left + 8)}px`;
    this.panelTarget.style.top = `${Math.round(tr.top)}px`;
  }
}
